import { Modal, Table, type TableColumn, TableOutput, type TableRow } from "@general-backoffice/core";
import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";

import spain from "../../media/flags/spain.png";
import uk from "../../media/flags/united-kingdom.png";
// import germany from "../../media/flags/germany.png"
// import france from "../../media/flags/france.png"
// import italy from "../../media/flags/italy.png"

const languages = [
  {
    code: "es",
    flag: spain,
    name: "Español",
  },
  {
    code: "en",
    flag: uk,
    name: "English",
  },
  // {
  //   code: 'fr',
  //   flag: france,
  //   name: "François"
  // },
  // {
  //   code: 'de',
  //   flag: germany,
  //   name: "Deutsch"
  // },
  // {
  //   code: 'it',
  //   flag: italy,
  //   name: "Italiano"
  // }
];

interface LanguageSelectorModalProps {
  isOpen: boolean;
  setOpen: (open: boolean) => void;
}

const LanguageSelectorModal = ({ isOpen, setOpen }: LanguageSelectorModalProps) => {
  const { t, i18n } = useTranslation("modals", { keyPrefix: "languageSelectorModal" });
  const selectedLang = useMemo(() => languages.find((l) => l.code === i18n.language) || languages[0], [i18n.language]);

  const columns: TableColumn[] = [
    {
      name: "",
      formattedContent: (row: TableRow) =>
        row.flag ? <TableOutput.ImageText src={row.flag} alt={row.name} text={row.name} /> : row.name,
      isTh: true,
    },
    {
      name: "",
      formattedContent: (row: TableRow) => (row.code === selectedLang?.code ? <i className="fas fa-check" /> : null),
    },
  ];

  const handleClick = async (lang: TableRow) => {
    if (lang?.code !== selectedLang?.code) {
      i18n.changeLanguage(lang?.code);
      setOpen(false);
    }
  };

  return (
    <Modal.Simple
      size="sm"
      isOpen={isOpen}
      toggleOpen={() => setOpen(!isOpen)}
      closeText={t("closeBtn")}
      title={t("title")}
    >
      <div className="overflow-hidden mb-0 mx--4 mb--4 mt--4">
        <div className="mt--5">
          <Table columns={columns} rows={languages} onRowClick={handleClick} selectable={false} sortable={false} />
        </div>
      </div>
    </Modal.Simple>
  );
};

export default LanguageSelectorModal;
